import { ChevronDownIcon } from '@systemeio/icons'
import type { ComponentPropsWithoutRef, ReactNode } from 'react'
import { twMerge } from 'tailwind-merge'

interface InputWithSelectsProps {
  className?: string
  endSelect?: ReactNode
  input: ReactNode
  startSelect?: ReactNode
}

type InputWithSelectsTriggerProps = ComponentPropsWithoutRef<'button'> & {
  side: 'start' | 'end'
  size?: 'sm' | 'md'
}

function InputWithSelects({ className, endSelect, input, startSelect }: InputWithSelectsProps) {
  return (
    <div
      className={twMerge(
        'flex items-end',
        startSelect && '[&_[data-slot=input-group]]:rounded-l-none [&_input]:rounded-l-none',
        endSelect && '[&_[data-slot=input-group]]:rounded-r-none [&_input]:rounded-r-none',
        className,
      )}
    >
      {startSelect}
      {input}
      {endSelect}
    </div>
  )
}

function InputWithSelectsTrigger({
  children,
  className,
  side,
  size = 'md',
  type = 'button',
  ...props
}: InputWithSelectsTriggerProps) {
  return (
    <button
      {...props}
      className={twMerge(
        'focus-visible:focus-ring-primary border-field-border bg-field-bg-secondary transition-base hover:bg-bg-tertiary disabled:bg-field-bg-disabled disabled:text-text-disabled flex items-center gap-2.5 border px-3 text-base outline-none data-popup-open:[&_svg]:rotate-180',
        side === 'start' ? 'rounded-l-md border-r-0' : 'rounded-r-md border-l-0',
        size === 'sm' ? 'h-8' : 'h-10',
        className,
      )}
      type={type}
    >
      {children}
      <ChevronDownIcon className="text-icon-primary transition-base size-5" />
    </button>
  )
}

export { InputWithSelects, InputWithSelectsTrigger }
export type { InputWithSelectsProps, InputWithSelectsTriggerProps }
